import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";
import {
    CAUSAL_ADVERS,
    CAUSAL_FAILURE,
    CAUSAL_IMPROPER,
    CAUSAL_MISAPPROPRIATION,
    CAUSAL_NONPAYMENT, CAUSAL_NOTIFICATION, CAUSAL_OTHER, CAUSAL_SINISTER, CAUSAL_SUBNOLO,
    CAUSAL_SUSPICIOUS,
    CAUSAL_VIOLATIONS
} from "../../finessecurity/component/Constants";


export const useCausalValues = () => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'blackList'});
    const theme = useTheme();

    const getCausalLabel = (status: any ) => {
        switch (status) {
            case CAUSAL_FAILURE: return t('causalValue.causalFailure');
            case CAUSAL_MISAPPROPRIATION: return t('causalValue.causalMisappropriation');
            case CAUSAL_SUSPICIOUS: return t('causalValue.causalSuspicious');
            case CAUSAL_NONPAYMENT: return t('causalValue.causalNonPayment');
            case CAUSAL_NOTIFICATION: return t('causalValue.causalNotification');
            case CAUSAL_VIOLATIONS: return t('causalValue.causalViolations');
            case CAUSAL_ADVERS: return t('causalValue.causalAdvers');
            case CAUSAL_OTHER: return t('causalValue.causalOther');
            case CAUSAL_IMPROPER: return t('causalValue.causalImproper');
            case CAUSAL_SUBNOLO: return t('causalValue.causalSubnolo');
            case CAUSAL_SINISTER: return t('causalValue.causalSinister');

            default : return '-'
        }
    };

    return {
        getCausalLabel
    }
}